
const MIN_EFFECTIVE_START_DATE = '0001-01-01'
const MAX_EFFECTIVE_END_DATE = '9999-01-01'

module.exports = {
  MIN_EFFECTIVE_START_DATE,
  MAX_EFFECTIVE_END_DATE,
}
